var map = {
	"./ico_default.png": 92972,
	"./ico_excel.png": 15946,
	"./ico_img.png": 55446,
	"./ico_pdf.png": 86441,
	"./ico_ppt.png": 71911,
	"./ico_rar.png": 45540,
	"./ico_txt.png": 96235,
	"./ico_word.png": 8019
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47684;